import React from "react";
import { Button, Result } from "antd";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const message = String(error?.message || error || "");
    const isChunkError = /Loading chunk \d+ failed|ChunkLoadError|Unexpected token '<'/i.test(message);

    if (isChunkError && !sessionStorage.getItem("mps_chunk_reload_done")) {
      sessionStorage.setItem("mps_chunk_reload_done", "1");
      window.location.reload();
      return;
    }

    if (process.env.NODE_ENV !== "production") {
      console.error("Erro capturado pelo ErrorBoundary", error, info);
    }
  }

  render() {
    if (!this.state.hasError) {
      sessionStorage.removeItem("mps_chunk_reload_done");
      return this.props.children;
    }

    return (
      <Result
        status="500"
        title="Algo correu mal"
        subTitle="A página encontrou um erro inesperado. A sessão continua protegida."
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            Recarregar
          </Button>
        }
      />
    );
  }
}
